import { Box } from "@mui/material";
import MapWithSearch from "../../../../../../components/maps/MapWithSearch/MapWithSearch";
import Input from "../../../../../../components/ui/Input";
import Text from "../../../../../../components/ui/Text";

const LocationSelection = ({
  gameData,
  onLocationSelect,
  onAddressChange,
  onVenueChange,
  onHowToFindUsChange,
}) => {
  return (
    <Box>
      <Text variant="subtitle3">Select a location</Text>
      <Box sx={{ display: "flex", mt: 2, flexDirection: "column" }}>
        <Box sx={{ mb: 2, order: 1 }}>
          <Input
            label="Game title"
            value={gameData.venue}
            onChange={(e) => onVenueChange(e.target.value)}
          />
        </Box>
        <MapWithSearch
          initialLocation={gameData.location}
          onVenueChange={onVenueChange}
          onAddressChange={onAddressChange}
          onLocationSelect={onLocationSelect}
        />
      </Box>
      <Box sx={{ mt: 2 }}>
        <Input
          label="How to find us (Optional)"
          value={gameData.how_to_find}
          onChange={onHowToFindUsChange}
        />
      </Box>
    </Box>
  );
};

export default LocationSelection;
